'use strict';

const React = require( 'react' );
const propTypes = require('prop-types');
const ReviewItem = require( './reviewItem.jsx' );
const { object } = propTypes;
const createReactClass = require('create-react-class');

const ReviewItems = createReactClass({
  propTypes: {
    reviews: object.isRequired
  },

  render() {
    const { reviews } = this.props;
    const reviewItems = [ ];
    for ( let i in reviews ) {
      reviewItems.push( <ReviewItem key={ i } item={ reviews[i] } /> );
    }

    return (
      <ul className="infostat unstyled">
        { reviewItems }
      </ul>
    );
  }
});

module.exports = ReviewItems;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/reviewItems.jsx